/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { SingleSelectState } from "./SingleSelectState";

/**
 * Creates a state for selecting a single entity using generic store.
 * @returns The created state for selecting a single entity using generic store.
 */
export function createSingleSelectState<TValue>(): SingleSelectState<TValue> {
    return {
        selectedValue: undefined
    };
}
